import React from "react";
import { Container, Box, Typography, Paper, Divider } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last Updated: May 26, 2026
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              1. Introduction
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Welcome to <strong>decodia.in</strong> ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              2. Information We Collect
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We may collect the following types of information:
            </Typography>
            <ul style={{ color: "rgba(0,0,0,0.7)", marginTop: 8 }}>
              <li><strong>Personal Information:</strong> Name, email address, phone number (if you voluntarily submit via forms).</li>
              <li><strong>Usage Data:</strong> IP address, browser type, pages visited, time and date of visit.</li>
              <li><strong>Cookies:</strong> Small files stored on your device to enhance user experience.</li>
            </ul>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              3. How We Collect Information
            </Typography>
            <ul style={{ color: "rgba(0,0,0,0.7)" }}>
              <li>When you fill out forms, subscribe to newsletters, or contact us.</li>
              <li>Automatically through cookies and analytics tools (e.g., Google Analytics).</li>
            </ul>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              4. How We Use Your Information
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We use the collected information to:
            </Typography>
            <ul style={{ color: "rgba(0,0,0,0.7)" }}>
              <li>Operate and maintain our website.</li>
              <li>Respond to your inquiries or comments.</li>
              <li>Improve user experience and analyze site traffic.</li>
              <li>Send periodic updates (only if you have opted in).</li>
            </ul>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              5. Third-Party Sharing
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We do not sell, trade, or rent your personal information to others. We may share data with:
            </Typography>
            <ul style={{ color: "rgba(0,0,0,0.7)" }}>
              <li>Service providers (hosting, analytics) who assist in website operations.</li>
              <li>Legal authorities if required by Indian law.</li>
            </ul>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              6. Cookies and Tracking Technologies
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We use cookies to remember user preferences and understand site usage patterns. You can disable cookies through your browser settings.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              7. Data Security
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We implement reasonable security measures to protect your data. However, no internet transmission is 100% secure.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              8. Your Rights (Under Indian Law)
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You have the right to:
            </Typography>
            <ul style={{ color: "rgba(0,0,0,0.7)" }}>
              <li>Access the personal data we hold about you.</li>
              <li>Request correction or deletion of your data.</li>
              <li>Withdraw consent at any time.</li>
            </ul>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              To exercise these rights, contact us at: <strong>info@decodia.in</strong>
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              9. Changes to This Privacy Policy
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We may update this policy occasionally. The "Last Updated" date at the top indicates when changes were made.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight="semibold">
              10. Contact Us
            </Typography>
            <Typography variant="body1" color="text.secondary">
              If you have questions about this Privacy Policy, please contact us at:
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Email: <strong>info@decodia.in</strong><br />
              Website: <strong>decodia.in</strong>
            </Typography>
          </section>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;